<template>
  <div role="dialog" tabindex="-1" aria-modal="false" class="time-picker__wrap">
    <picker
      v-model="hoursDisplay"
      name="Hours"
      :min="1"
      :max="12"
      v-on:increment="changeTime({ field: 'hours', action: 'increment' })"
      v-on:decrement="changeTime({ field: 'hours', action: 'decrement' })"
    />
    <picker
      v-model="minutesDisplay"
      name="Minutes"
      :min="0"
      :max="59"
      v-on:increment="changeTime({ field: 'minutes', action: 'increment' })"
      v-on:decrement="changeTime({ field: 'minutes', action: 'decrement' })"
    />
    <picker
      v-model="amPmDisplay"
      name="AM/PM"
      v-on:increment="changeTime({ field: 'ampm', action: 'increment' })"
      v-on:decrement="changeTime({ field: 'ampm', action: 'decrement' })"
    />
  </div>
</template>

<script>
import Picker from "./TimePicker/Picker";

const leadingZeroes = value => (value.length < 2 ? "0" + value : value);

export default {
  name: "time-picker",
  props: {
    value: String,
  },
  components: {
    Picker,
  },
  methods: {
    changeTime: function({ field, action }) {
      let [hours, minutes] = this.value.split(":").map(t => parseInt(t));
      let change = 0;

      /**
       * either increment by adding 1 or decrement by adding -1
       */
      if (action === "increment") {
        change = 1;
      }
      if (action === "decrement") {
        change = -1;
      }

      /**
       * increment or decrement hours if hours was passed in as the field
       */
      if (field === "hours") {
        // increment or decrement by one hour
        hours = hours + change;
      }

      /**
       * increment or deccrement minutes if minutes was passed in as the field
       */
      if (field === "minutes") {
        minutes = minutes + change;
      }

      /**
       * toggle between AM and PM
       * just adds 12 hours and lets hours roll over to the correct time
       * for example noon (12:00) + 12 hours becomes 24:00 and rolls over
       * to become midnight (00:00)
       */
      if (field === "ampm") {
        hours = hours + 12;
      }

      /**
       * Hours / minutes rollover logic
       * for if hours or minutes go below 0
       * or hours exceed 23
       * or minutes exceed 59
       */
      // do not let minutes get to 60, add 1 to the hour instead
      if (minutes === 60) {
        minutes = 0;
        hours = hours + 1;
      }
      // do not let minutes get to -1, subtract 1 from the hour instead
      if (minutes < 0) {
        minutes = 59;
        hours = hours - 1;
      }
      // do not let hours get to 24, roll over by subtracting 24
      if (hours > 23) {
        hours = hours - 24;
      }
      // do not let hours get to -1, roll over by adding 24
      if (hours < 0) {
        hours = hours + 24;
      }

      hours = hours.toString();
      minutes = minutes.toString();

      const newTime = `${leadingZeroes(hours)}:${leadingZeroes(minutes)}`;

      // output new time to parent component
      this.$emit("input", newTime);
    },
  },
  computed: {
    // displays only the hours in 12 hour time
    hoursDisplay: function() {
      const [hours] = this.value.split(":").map(t => parseInt(t));
      let hours12 = hours;
      if (hours > 12) {
        hours12 = hours - 12;
      }
      if (hours <= 12) {
        hours12 = hours;
      }
      if (hours === 0) {
        hours12 = 12;
      }
      hours12 = hours12.toString();

      return leadingZeroes(hours12);
    },
    minutesDisplay: function() {
      const [, minutes] = this.value.split(":").map(t => parseInt(t));
      return leadingZeroes(minutes.toString());
    },
    amPmDisplay: function() {
      const [hours] = this.value.split(":").map(t => parseInt(t));
      if (hours >= 12) {
        return "PM";
      }
      return "AM";
    },
  },
};
</script>

<style lang="scss">
@import "../styles/components/_time-picker.scss";
</style>
